import { createFileRoute } from "@tanstack/react-router";
import { DemandasPanel } from "@/components/admin/DemandasPanel";
import { paginationValidator } from "@/hooks/use-table-pagination";

export const Route = createFileRoute("/admin/demandas")({
  validateSearch: paginationValidator,
  component: DemandasPanel,
});
